import { defineComponent as _defineComponent } from 'vue'
import { isElementInViewport, isElementOnTopOfViewport } from 'bits/dom'
import { difference } from 'lodash-es'
import { storeToRefs } from 'pinia'
import { useSurfacePostsStore } from 'pinia/surface_posts'
import type { Post } from 'types'
import { Ref, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfacePostsAnimationWrapper',
  setup(__props) {

const surfacePostsStore = useSurfacePostsStore()
const { currentSortedPosts } = storeToRefs(surfacePostsStore)
const isAnimationPermitted = ref(false)
const postsDisappearing: Ref<Post[]> = ref([])

// TODO: If we want to add filter animation back,
// add a watcher on the new filter state to trigger
// this method.
// Only allow animation when filter is changing
// watch(filter, (filterValue) => {
//   if (filterValue) {
//     isAnimationPermitted.value = true
//   }
// })

// Disallow animation after animation is done
function endAnimationForFilterChanged() {
  isAnimationPermitted.value = false
}

// When posts are changing, check if any of them are in viewport
// Only the ones in viewport will be animated
watch(currentSortedPosts, (newVal: Post[], oldVal: Post[]) => {
  const postDifference = difference(oldVal, newVal)
  postsDisappearing.value = postDifference.filter((p) => {
    const postElement = document.querySelector(`#wish-${p.id}`)
    if (!postElement) return false
    return isElementInViewport(postElement)
  })
})

// Set up element height for animation to work
// CSS height can only be animated if it's set to a specific value
function setHeight(el: HTMLElement) {
  el.style.height = `${el.getBoundingClientRect().height}px`
}

// Animate posts that are disappearing and in viewport
function staggerWishLeave(el: HTMLElement) {
  if (!isAnimationPermitted.value) return
  const positionInHidingOrder = postsDisappearing.value.findIndex((p: Post) => p.cid === el.dataset.cid)
  const delay = (300 / (postsDisappearing.value.length - 1)) * Math.max(positionInHidingOrder, 0)
  el.style.transition = isElementOnTopOfViewport(el) // if post is on top, we hide them with animation so that the scrollbar does not jump
    ? 'all 500ms cubic-bezier(0,0,0.2,1)'
    : positionInHidingOrder < 0
    ? 'none'
    : postsDisappearing.value.length === 1
    ? 'all 500ms cubic-bezier(0,0,0.2,1)'
    : 'all 200ms cubic-bezier(0,0,0.2,1)'
  el.style.opacity = `1`
  setTimeout(() => {
    el.style.height = `0px`
    el.style.margin = `0px`
    el.style.opacity = `0`
  }, delay)
}

return { __sfc: true,surfacePostsStore, currentSortedPosts, isAnimationPermitted, postsDisappearing, endAnimationForFilterChanged, setHeight, staggerWishLeave }
}

})